export default function showNotificationSignup() {
	document.addEventListener('submit', async function(event) {
		const form = event.target;
		if (!(form instanceof HTMLFormElement) || !form.matches('.show-notification-form')) {
			return;
		}

		event.preventDefault();

		const emailInput = form.querySelector('input[name="email"]');
		const error = form.querySelector('.newsletter-inline__msg--error');
		const email = (emailInput?.value || '').trim().toLowerCase();

		if (!emailInput || !emailInput.checkValidity() || !email) {
			error.textContent = 'Please enter a valid email address.';
			error.hidden = false;
			emailInput?.focus();
			return;
		}

		const success = form.querySelector('.newsletter-inline__msg--success');
		const button = form.querySelector('button[type="submit"]');
		const buttonText = button.querySelector('.newsletter-inline__submit-text');
		const originalButtonText = buttonText.textContent;
		error.hidden = true;
		success.hidden = true;
		button.disabled = true;
		buttonText.textContent = 'Signing up…';
		form.setAttribute('aria-busy', 'true');

		try {
			const response = await fetch(form.dataset.rest, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				credentials: 'same-origin',
				body: JSON.stringify({ email })
			});
			const result = await response.json().catch(function() {
				return {};
			});

			if (!response.ok) {
				throw new Error(result.message || 'Sorry, we could not complete your signup.');
			}

			form.reset();
			success.textContent = 'Thank you for signing up.';
			success.hidden = false;
			form.classList.add('show-notification-form--success');
		} catch (requestError) {
			error.textContent = requestError.message || 'Sorry, we could not complete your signup.';
			error.hidden = false;
		} finally {
			button.disabled = false;
			buttonText.textContent = originalButtonText;
			form.removeAttribute('aria-busy');
		}
	});
}
